import { connectRedux } from '@om1/platform-utils'
import { HomePageProfileComponent } from './HomeProfileComponent'

export function createHomePageProfileComponent<TState extends { platformConfig: any }>() {
    return connectRedux(HomePageProfileComponent, (state: TState) => {
        return { ...state.platformConfig }
    })
}

export type HomePageProfile = ReturnType<typeof createHomePageProfileComponent>
